import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

const FooterBox = styled(Box)({
  padding: "1rem",
  textAlign: "center",
  color: "#333",
  marginTop: "2rem"
});

const InfoBar = styled(Box)({
  backgroundColor: "#FFD8A8",
  textAlign: "center",
  padding: "0.5rem",
  marginBottom: "1rem"
});

export const Footer = () => {
  return (
    <FooterBox>
      <InfoBar>
        <Typography variant="body1" sx={{ fontWeight: "bold", color: "#444" }}>
          Para más información, consultá la Guía para la Escritura de Requerimientos del INCOSE:{" "}
          <a
            href="https://incose.org/docs/default-source/working-groups/requirements-wg/rwg_products/incose_rwg_gtwr_summary_sheet_2022.pdf"
            style={{ color: "#FF9800" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            enlace aquí
          </a>  Los resultados del análisis son meramente informativos y podrían requerir interpretación humana dependiendo del contexto.
        </Typography>
      </InfoBar>
    </FooterBox>
  );
};
